import React from 'react'
import './Header.css';

export default function Header() {
  return (
    <>
    <header id="header" className="alt">
      <nav>
        <a href="/" ><img src="/images/ambition.png" alt=""></img></a>
      </nav>
    </header>
    </>
  )
}
